import { Box, Paper, Typography } from '@mui/material';
import { GiWeight } from "react-icons/gi";
import { FaUser } from "react-icons/fa";
import { PiNotePencilFill } from "react-icons/pi";
import './StatCard.css';

const icons = {
    "kg": <GiWeight color='white' size={30}/>,
    "count": <PiNotePencilFill color='white' size={20}/>,
    "utilisateurs": <FaUser color='white' size={20}/>
}

const StatCard = ({ title, value, unit, showUnit}) => {
    return (
        <Paper className="stat-card" elevation={3} style={{backgroundColor: "#00265A", margin: "0.5rem" }}>
            <Box display="flex" flexDirection="column" alignItems="center">
                <Box display="flex" flexDirection="row" alignItems="center" justifyItems={"space-between"}>
                    <Typography variant="subtitle1" component="div" color='white'>
                        {title}&nbsp;
                    </Typography>
                    {icons[unit]}
                </Box>
                <Box display="flex" flexDirection="row" alignItems="baseline">
                    <Typography variant="h4" component="div" color='white' style={{fontWeight: "bold"}}>
                        {isNaN(value) ? value :  Number(value).toPrecision(3)}
                    </Typography>
                    {showUnit && <Typography variant="body1" component="div" color='white'>
                    &nbsp;{unit}
                    </Typography>}
                </Box>
            </Box>
        </Paper>
    );
}
export default StatCard;